/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cta_SubInputs */

const en_pc_cta_sub = /** @type {(inputs: Pc_Cta_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free, open source and runs right in your browser.`)
};

const zh_pc_cta_sub = /** @type {(inputs: Pc_Cta_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费、开源，打开浏览器就能用。`)
};

/**
* | output |
* | --- |
* | "Free, open source and runs right in your browser." |
*
* @param {Pc_Cta_SubInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cta_sub = /** @type {((inputs?: Pc_Cta_SubInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cta_SubInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cta_sub(inputs)
	return zh_pc_cta_sub(inputs)
});
export { pc_cta_sub as "pc.cta.sub" }